import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { Team } from "@/components/site/Team";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Manifesto />
        <About />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
